import Interstitial from "../../../../src/components/interstitial";
import * as React from 'react';
export default {
  Interstitial,
  React
};